import { render, staticRenderFns } from "./SOVnesplusDetailed.vue?vue&type=template&id=1f275e8f&scoped=true"
import script from "./SOVnesplusDetailed.vue?vue&type=script&lang=js"
export * from "./SOVnesplusDetailed.vue?vue&type=script&lang=js"
import style0 from "./SOVnesplusDetailed.vue?vue&type=style&index=0&id=1f275e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f275e8f",
  null
  
)

export default component.exports